import { FORMAT } from '../core/format'
import { UTILS } from '../../utils';
import { MOMENT_TIME } from '../../momenttime';

var FAMOUS_PEDIA_DATA_MANAGER = {
    /**
     * 根据服务器返回列表数据获取前端所需商品列表数据
     * @param {服务器返回列表数据} list 
     */
    getFamousPediaListByList(list) {
        var resultList = [], resultData = {};
        list.forEach(data => {
            var starttime = data.real_time == 0 ? data.birthdayDate : data.realDate;
            var newData = {
                type: 'hot',
                id: data.id,
                name: data.f_name,
                sex: data.sex == 0 ? "男" : "女",
                dateStr: starttime.slice(0, -3),
                pvNum: data.pv,
                replyNum: data.reply,
                eightWordArr: FORMAT.getEightWordArrByData(data.unknown, data)
            }
            resultData[data.id] = data;
            resultList.push(newData);
        });
        return {
            'resultList': resultList,
            'resultData': resultData
        };
    },
    /**
     * 根据服务器返回列表数据获取前端所需商品列表数据
     * @param {服务器返回列表数据} list 
     * @param {服务器返回的用户信息数据} userinfo 
     */
    getFamousPediaNewListByList(list, userinfo) {
        var resultList = [], resultData = {};
        list.forEach(data => {
            var starttime = data.real_time == 0 ? data.birthdayDate : data.realDate;
            var newData = {
                type: 'new',
                id: data.id,
                name: data.f_name,
                sex: data.sex == 0 ? "男" : "女",
                dateStr: starttime.slice(0, -3),
                creator: userinfo[data.uid] && userinfo[data.uid].nickname ? userinfo[data.uid].nickname : '匿名',
                eightWordArr: FORMAT.getEightWordArrByData(data.unknown, data)
            }
            resultData[data.id] = data;
            resultList.push(newData);
        });
        return {
            'resultList': resultList,
            'resultData': resultData
        };
    },
    /**
     * 根据服务器返回列表数据获取前端所需商品列表数据
     * @param {服务器返回列表数据} list 
     * @param {服务器返回的用户信息数据} userinfo 
     * @param {数据类型} type 
     */
    getFamousPediaListByListType(list, userinfo, type) {
        var resultList = [], resultData = {};
        if(list && list.length > 0) {
            list.forEach(data => {
                var starttime = data.baike.real_time == 0 ? data.baike.birthdayDate : data.baike.realDate;
                var newData = {
                    type: type,
                    id: data.baike.id,
                    name: data.baike.f_name,
                    sex: data.baike.sex == 0 ? "男" : "女",
                    dateStr: starttime.slice(0, -3),
                    creator: userinfo[data.baike.uid] && userinfo[data.baike.uid].nickname ? userinfo[data.baike.uid].nickname : '匿名',
                    status: data.base.f_status,
                    statusStr: FORMAT.getBaikeStatusByNumber(data.base.f_status),
                    eightWordArr: FORMAT.getEightWordArrByData(data.baike.unknown, data.baike)
                }
                resultData[data.baike.id] = data;
                resultList.push(newData);
            });
        }
        return {
            'resultList': resultList,
            'resultData': resultData
        };
    },
    /**
     * 根据服务器返回新增的百科数据，获取前段所需数据并更新列表
     * @param {新增百科数据} data 
     * @param {创建者} creator 
     */
    getFamousPediaMyListByAddedData(data, creator) {
        var status = 3,
            starttime = data.real_time == 0 ? data.birthdayDate : data.realDate;
        var newData = {
            type: 'my',
            id: data.id,
            name: data.f_name,
            sex: data.sex == 0 ? "男" : "女",
            dateStr: starttime.slice(0, -3),
            creator: creator,
            status: status,
            statusStr: FORMAT.getBaikeStatusByNumber(status),
            eightWordArr: FORMAT.getEightWordArrByData(data.unknown, data)
        }
        return newData;
    },
    /**
     * 
     * @param {当前列表数据} origiList 
     * @param {修改的八字id} baziId 
     * @param {修改的键} key 
     * @param {修改的键对应的值} value 
     */
    updatePediaListDataByKeyValue(origiList, baziId, key, value) {
        origiList.forEach((data, index) => {
            if(data.id == baziId) {
                origiList[index][key] = value;
                // 如果是status更新的话,要同时更新statusStr字段
                if(key == 'status') {
                    origiList[index]['statusStr'] = FORMAT.getBaikeStatusByNumber(value);
                }
            }
        });
        return origiList;
    },
    /**
     * 根据八字数据获取addBaike的参数
     * @param {八字数据} data 
     */
    getBaiKeParamsByData(data) {
        var params = {
            f_name: data.f_name,
            birthday: data.birthdayDate,
            location: data.location,
            sex: data.sex,
            real_time: data.realDate,
            zwzs: data.zwzs,
            unknown: data.unknown
        }
        return params;
    },
    /**
     * 根据服务器返回百科数据获取百科编辑相关信息
     * @param {服务器返回百科信息数据} data 
     */
    getBaiKeEditInfoByData(data) {
        var creator = data.userinfo[data.baike.uid] ? data.userinfo[data.baike.uid] : {},
            lastEditor = data.log.last && data.userinfo[data.log.last.uid] ? data.userinfo[data.log.last.uid] : {};
        var newData = {
            creatorName: creator ? creator.nickname : '匿名',
            pvTime: data.baike.pv,
            editTime: data.log.num,
            editLastName: lastEditor ? lastEditor.nickname : '匿名',
            editLastTime: data.log.last && data.log.last.f_createtime ? UTILS.getTimeInfoByTimeString(data.log.last.f_createtime) : ''
        };
        return newData;
    },
    /**
     * 根据服务器返回百科数据获取百科编辑历史列表
     * @param {服务器返回百科信息数据} data 
     */
    getBaiKeEditHistoryListByData(data) {
        var resultList = [];
        if(data.info.length > 0) {
            data.info.forEach(element => {
                var editor = data.userinfo[element.uid] ? data.userinfo[element.uid] : null;
                resultList.push({
                    id: element.id,
                    updateTime: element.f_createtime,
                    editorName: editor ? editor.nickname : '匿名',
                    editInfo: element.msg
                });
            })
        }
        return resultList;
    },
    /**
     * 根据服务器返回数据获得一个评论数据
     * @param {服务器返回评论数据} data 
     * @param {服务器返回评论的用户数据} userinfo 
     */
    getCommentData(data, userinfo) {
        var userData = userinfo && userinfo[data.uid] ? userinfo[data.uid] : {},
            toData = userinfo && userinfo[data.touid] ? userinfo[data.touid] : {};
        var resultData = {
            id: data.id,
            key: data.f_type,
            uid: data.uid,
            userName: userData.nickname ? userData.nickname : '匿名',
            userAvatar: userData.avatar ? userData.avatar : '',
            parentsid: data.parentsid,
            touid: data.touid,
            toName: toData.nickname ? toData.nickname : '匿名',
            msg: data.msg,
            likeNum: data.f_like,
            isLike: data.islike,
            isDelete: data.f_status == 2 ? true : false,
            time: MOMENT_TIME.getUnixTimeByTimeStr(data.f_time),
            timeStr: UTILS.getTimeInfoByTimeString(data.f_time)
        }
        return resultData;
    },
    /**
     * 根据服务器返回的数据获取前端所需评论数据
     * @param {服务器返回评论数据} data 
     */
    getCommentTotalDataByData(data) {
        var firstData = {}, secondData = {},
            replyData = data.reply ? data.reply : {};
        for(var key in replyData) {
            firstData[key] = [];
            // console.log('key--------', key, replyData[key], firstData[key])
            for(var key2 in replyData[key]) {
                var newData = FAMOUS_PEDIA_DATA_MANAGER.getCommentData(replyData[key][key2], data.userinfo);
                firstData[key].push(newData);
                secondData[newData.id] = [];
                var replyList = replyData[key][key2].reply;
                if(replyList.length > 0) {
                    for(var i = 0; i < replyList.length; i++) {
                        // console.log('secondlist-------', replyList[i])
                        var newData2 = FAMOUS_PEDIA_DATA_MANAGER.getCommentData(replyList[i], data.userinfo);
                        secondData[newData.id].push(newData2);
                    }
                }
                // console.log('key2--------', key2, replyList);
            }
        }
        return {
            first: firstData,
            second: secondData
        };
    },
    /**
     * 完善评论基础数据:新增用
     * @param {评论表单数据} formData 
     */
    supplyCommentDataByFormData(formData, newData) {
        var resultData = Object.assign(newData, formData);
        resultData = Object.assign({
            f_like: 0,
            islike: 0,
            f_status: 1,
            f_time: MOMENT_TIME.getFormateTimeByTimeStamp(),
        }, resultData);
        return resultData;
    },
    /**
     * 根据当前查看全部列表的数据获取全部列表的评论数据
     * @param {当前评论列表} listData 
     */
    getCommentAllListDataByList(listData) {
        var goodList = [], mainList = [], tempLen = 0, tempList = [];
        tempList = listData.filter(data => {return data.likeNum >= 5});
        tempLen = tempList.length;
        mainList = listData.filter(data => {return data.likeNum < 5});
        if(tempLen >= 0 && tempLen <= 3) {
            goodList = [].concat(tempList);
        }else if(tempLen > 3) {
            goodList = [].concat(tempList.slice(0, 3));
            mainList = tempList.slice(3).concat(mainList);
        }
        return {
            'good': goodList,
            'main': mainList
        }
    },
    /**
     * 
     * @param {当前评论列表的key值} key 
     * @param {大运流年数据} dayunLiunianList 
     */
    getCommentAllDataInfoByKey(key, dayunLiunianList) {
        var keyArr = key != '' ? key.split('_') : [],
            dyIndex = keyArr[1] ? parseInt(keyArr[1].slice(3)) : null,
            lnIndex = keyArr[2] ? parseInt(keyArr[2].slice(1)) : null;
        var dyData = dyIndex != null ? (dayunLiunianList.length == 10 ? dayunLiunianList[dyIndex - 1] : dayunLiunianList[dyIndex]) : null,
            lnData = dyData && dyData != null && lnIndex != null ? dyData.liunian[lnIndex - 1] : null;
        console.error('getCommentAllDataInfoByKey-----', keyArr, dyIndex, lnIndex, dyData, lnData)
        return lnData;
    }
}

export {
    FAMOUS_PEDIA_DATA_MANAGER
}